import { render, staticRenderFns } from "./protocolos-processos-ug.vue?vue&type=template&id=3785cc5c"
import script from "./protocolos-processos-ug.vue?vue&type=script&lang=js"
export * from "./protocolos-processos-ug.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./protocolos-processos-ug.vue?vue&type=style&index=1&id=3785cc5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports